var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof FIRST_APP !== "undefined") return resolve();
	__webpack_require__.l("https://av-cdn-v2.s3.ap-southeast-1.amazonaws.com/microfrontend/portfolio/remoteEntry.js", (event) => {
		if(typeof FIRST_APP !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "FIRST_APP");
}).then(() => (FIRST_APP));